import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { Admin } from "~/api/admins";
import type { AuthResponse, RefreshResponse } from "~/api/types";

export interface UserStoreState {
  admin: Admin | null;
  setAdmin(admin: Admin | null): void;
  accessToken: string | null;
  expiresAt: number | null;
  setAuth(authData: AuthResponse | RefreshResponse): void;
  logout(): void;
}

export const useUserStore = create<UserStoreState>()(
  persist(
    (set) => ({
      admin: null,
      accessToken: null,
      expiresAt: null,
      setAdmin: (admin: Admin | null) => {
        set(() => ({ admin }));
      },
      setAuth: (authData: AuthResponse | RefreshResponse) => {
        const expiresAt = new Date().getTime() + authData.expiresIn * 1000;
        set(() => ({
          accessToken: authData.accessToken,
          expiresAt,
        }));
      },
      logout: () => {
        set(() => ({
          accessToken: null,
          expiresAt: null,
          admin: null,
        }));
        // Clear persisted storage
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("useUserStore");
        }
      },
    }),
    {
      name: "useUserStore",
    },
  ),
);
